import {createRouter, createWebHistory} from "vue-router";

import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServiceView from "../views/ServiceView.vue";
import ServiceDetailView from "../views/ServiceDetailView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import DatenschutzView from "@/views/DataSecurityView.vue";
import ContactView from "@/views/ContactView.vue";
import ReferencesView from "@/views/ReferencesView.vue";
import CareerView from "@/views/CareerView.vue";

const routes = [
    {path: "/", name: "home", component: HomeView, meta: {title: "Home"}},
    {path: "/ueber", name: "ueber", component: AboutView, meta: {title: "Über mich"}},
    {path: "/leistungen", name: "leistungen", component: ServiceView, meta: {title: "Leistungen"}},
    {path: "/leistungen/:slug", name: "leistung-detail", component: ServiceDetailView, meta: {title: "Leistung im Detail"}},
    {path: "/impressum", name: "impressum", component: ImpressumView, meta: {title: "Impressum"}},
    {path: "/karriere", name: "karriere", component: CareerView, meta: {title: "Karriere"}},
    {
        path: "/datenschutz",
        name: "datenschutz",
        component: DatenschutzView,
        meta: {title: "Datenschutz"}
    },
    {path: "/kontakt", name: "kontakt", component: ContactView, meta: {title: "Kontakt"}},
    {
        path: "/referenzen",
        name: "referenzen",
        component: ReferencesView,
        meta: {title: "Referenzen"}
    },
];


const scrollBehavior = (
    _to: unknown,
    _from: unknown,
    _savedPosition: { left: number; top: number } | null
) => {
    return _savedPosition ?? {top: 0}
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior
})

export default router;
